import { Link } from "react-router-dom";
import { Wordmark } from "./shared";

export const Footer = () => (
  <footer className="border-t border-[#F2F0EB]/5 pt-12 sm:pt-16 pb-8 sm:pb-10 overflow-hidden" data-testid="footer-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col sm:flex-row justify-between gap-8 mb-10 sm:mb-16">
        <div className="max-w-xs">
          <div data-testid="footer-logo">
            <Wordmark className="h-4" />
          </div>
          <p className="font-mono-brand text-[9px] tracking-[0.3em] text-[#6E7178] mt-3">
            KNOW YOUR DAY BEFORE IT STARTS
          </p>
          <p className="text-sm text-[#6E7178] leading-relaxed mt-6">
            One clear call every morning. Not prediction. Direction.
          </p>
        </div>
        <div className="flex gap-12 text-sm">
          <div className="flex flex-col gap-3">
            <span className="eyebrow mb-1">Product</span>
            <a href="#instrument" className="text-[#9DA1A8] hover:text-[#F2F0EB] transition-colors" data-testid="footer-link-system">What's inside</a>
            <a href="#how" className="text-[#9DA1A8] hover:text-[#F2F0EB] transition-colors" data-testid="footer-link-how">How it works</a>
            <a href="#faq" className="text-[#9DA1A8] hover:text-[#F2F0EB] transition-colors" data-testid="footer-link-faq">FAQ</a>
          </div>
          <div className="flex flex-col gap-3">
            <span className="eyebrow mb-1">Legal</span>
            <Link to="/privacy" className="text-[#9DA1A8] hover:text-[#F2F0EB] transition-colors" data-testid="footer-link-privacy">Privacy</Link>
            <Link to="/terms" className="text-[#9DA1A8] hover:text-[#F2F0EB] transition-colors" data-testid="footer-link-terms">Terms</Link>
          </div>
        </div>
      </div>
      <p className="text-center text-xs text-[#6E7178] mt-8 font-mono-brand tracking-widest">
        © 2026 SOURCECODED · KNOW YOUR PEAK. KNOW YOUR DIP.
      </p>
    </div>
  </footer>
);
